import React, { Component } from 'react';
import { connect } from 'react-redux';
import { func } from 'prop-types';
import { faq } from '../../services/ApiService';
import { startSetFaqSearch } from '../../actions/faq';
import WithPlaceholder from '../../hoc/WithPlaceholder';
import FaqSearchResults from './FaqSearchResults';
import { debounce } from '../../utils/utils';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

class FaqSearch extends Component {
  static propTypes = {
    startSetFaqSearch: func.isRequired,
  };

  static defaultProps = {};

  state = {
    loading: false,
    query: '',
    results: [],
    open: false,
  };

  handleChange = ({ target }) => {
    const query = target.value;

    if (query.length > 0) {
      this.setState(
        () => ({ query, open: false }),
        () => {
          const { query } = this.state;
          query.length > 3 && this.search(query);
        },
      );
    } else {
      this.setState(() => ({
        query: '',
        results: [],
        open: false,
      }));
    }

    this.setState(
      () => ({ [target.name]: target.value }),
      () => {
        const q = this.state.query;
      },
    );
  };

  search = debounce((q) => {
    this.setState(() => ({ loading: true }));

    faq.search({ q }).then(({ items: results = [] }) => {
      this.setState(() => ({
        loading: false,
        open: true,
        results,
      }));
    });
  }, 500);

  componentDidMount() {
    document.addEventListener('mousedown', this.closeOnDocumentClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.closeOnDocumentClick);
  }

  handleRef = (el) => (this.$ref = el);

  closeOnDocumentClick = (e) => {
    if (this.$ref && !this.$ref.contains(e.target)) {
      this.setState(() => ({
        open: false,
      }));
    }
  };

  focusHandler = () => {
    const { results } = this.state;

    if (results.length === 0) return;

    this.setState(() => ({
      open: true,
    }));
  };

  render() {
    const { loading, open, query, results } = this.state;

    return (
      <div className={open ? 'faq-search open' : 'faq-search'} ref={this.handleRef}>
        <WithPlaceholder
          className="faq-search-field"
          placeholder="main.search"
          defaultMessage="Search"
          maxLength="255"
          value={query}
          onChange={this.handleChange}
          readOnly={loading}
          onFocus={this.focusHandler}
          autoComplete="off"
        />
        <SVG
          className="faq-search-icon"
          src={`${STATIC_PATH}/img/action-icons/search_icon.svg`}
          height="24"
          width="24"
          cacheRequests
        />

        {!loading && open && <FaqSearchResults results={results} />}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startSetFaqSearch: (params) => dispatch(startSetFaqSearch(params)),
});

export default connect(null, mapDispatchToProps)(FaqSearch);
